import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import VueAxios from 'vue-axios'


import 'leaflet/dist/leaflet.css';

import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'

import Multiselect from 'vue-multiselect'


import Modal from "@burhanahmeed/vue-modal-2";

import feather from 'vue-icon'
Vue.use(feather, 'v-icon')
Vue.use(VueAxios, axios)



Vue.use(Modal);
Vue.config.productionTip = false;




// register globally
Vue.component('multiselect', Multiselect)
Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
